(function(window, undefined) {

    'use strict';

    /**
     * sapo videos metadata parsing code. relies on CORS and XML resources
     */
    var jsonpCORS = SAPO.Utility.jsonpCORS;

    var feat = SAPO.Project.Video.Features;

    var videoSourceRgx = /^(https?:)?(\/\/)?([a-z0-9\.]+)\/([^\/]{20})\/mov\/(\d+)/;
    var domainRegex    = /^(https?:)?(\/\/)?([a-z0-9\.]+)\//;
    var guidRegex      = /^(https?:)?(\/\/)?([a-z0-9\.]+)\/([^\/]{20})/;
    var protocol       = feat.pageProtocol();

    var processItemMetadata = function process_item_metadata(item, domain){
        //item.guid = item.guid.replace('videos.sapo.pt', 'rd.videos.sapo.pt')
        var m = guidRegex.exec(item.guid);
        guidRegex.lastIndex = 0;
        if (!m) {
            return;
        }
        var ret = {
            fromSapoVideos:  true,
            protocol:        protocol, //location.protocol,
            domain:          domain || m[3],
            hash:            m[4],
            encid:           m[5] || '1' // 1/39 SD/HD | 24 LIVE
        };

        ret.queryDomain   = [ret.protocol, '//', ret.domain].join('');
        ret.poster        = item['media:content'].url;
        ret.title         = item.title;
        //ret.guid          = item.guid;
        ret.link          = item.guid; // Original GUID for usage in sv_share
        ret.synopse       = item['sapo:synopse'];
        ret.author        = item['sapo:author'];
        ret.relatedVideos = item['sapo:relatedVideos'];
        ret.hasHD         = item['sapo:HD'];
        ret.hasSubtitles  = item.have_subtitle;
        ret.advertise     = !item['sapo:advertise'];
        ret.adwordsId     = parseInt( item['sapo:adwords_id'], 10);
        ret.tags          = item['sapo:tags'].split(' ');
        ret.canPublish    = item['sapo:canpublish'];

        m = domainRegex.exec(item.guid);
        if (!m) {
            //console.log('URI not in the SAPO videos format: ' + ret.guid);
            return false;
        }
        domainRegex.lastIndex = 0;

        ret.guidDomain  = [ret.protocol, domain || m[3]].join('//'); // for public consumption
        ret.videoDomain = [ret.protocol, ret.domain].join('//');

        ret.fullURI     = [ret.guidDomain, ret.hash, 'mov', ret.encid].join('/');
        ret.requestURL  = ret.fullURI;
        ret.pageURI     = [ret.guidDomain, ret.hash].join('/');
        ret.authorURI   = [[ret.protocol, m[3]].join('//'), ret.author].join('/');
        ret.guid        = ['/', ret.domain,  ret.hash].join('/');
        if (isNaN(ret.adwordsId)) { delete ret.adwordsId; }

        try {
            ret.duration = parseInt( item['sapo:time'] , 10 );
            if (isNaN(ret.duration)) { throw 'bang'; }
        } catch (ex) {
            delete ret.duration;
        }

        var vs = item['sapo:videoSize'];
        if (vs) {
            vs = vs.split('x');
            ret.dimensions = [
                parseInt(vs[0], 10),
                parseInt(vs[1], 10)
            ];
        }

        ret.poster = ret.poster.substring(0, ret.poster.lastIndexOf('/'));

        return ret;

    };

    SAPO.Project.Video.processItemMetadata = processItemMetadata;

    SAPO.Project.Video.sapoVideosMetadata = function(uri, cb) {
        var m = videoSourceRgx.exec(uri);
        videoSourceRgx.lastIndex = 0;
        if (!m) {
            return cb('URI not in the SAPO videos format: ' + uri);
        }


        var metaUri = [protocol, '//', m[3], '/', m[4], '/', 'rss2'].join('');

        //console.log('CALLING METADATA: ', metaUri);

        var onOk = function(item) {
            var md = processItemMetadata(item, m[3]);
            cb(null, md);
        };

        var onErr = function() {
            cb('Error fetching video metadata!', {});
        };

        jsonpCORS(metaUri, onOk, onErr, 5);
    };

})(window);
